<template>
  <div class="l-row">
    <form-group :label="$t('category.label')">
      <multiselect
        v-model="newItem.from.category"
        :options="from.categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="$t('departments.label')" :columns="3">
      <multiselect
        v-model="department"
        :options="to.departments"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="code"
      />
    </form-group>

    <form-group :label="$t('category.label')" :columns="3" v-if="newItem.to.department !== null && showCategories">
      <multiselect
        v-model="category"
        :options="to.categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="code"
      />
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      from: {
        categories: []
      },
      to: {
        departments: [],
        categories: []
      },
      newItem: {
        from: {
          category: null
        },
        to: {
          department: null,
          category: null
        }
      },
      department: null,
      category: null,
      cloneCategories: null,
      items: [],
      alreadyExists: false,
      showCategories: false,
      loaderCategories: true,
      loaderDepartments: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getCategories(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(categories => {
          this.from.categories = categories
          this.loaderCategories = false
          this.hideItem()
          this.$emit('loading', this.loaderCategories || this.loaderDepartments)
        })
        .catch(() => notifier.error('Impossível carregar as categorias da Moovin.', 'Erro'))

      api.getCategories(this.preset.to.module.type, this.preset.to.module.identifier)
        .then(departments => {
          this.to.departments = departments
          this.loaderDepartments = false
          this.$emit('loading', this.loaderCategories || this.loaderDepartments)
        })
        .catch(() => notifier.error('Impossível carregar os departamentos da Cnova.', 'Erro'))
    },
    methods: {
      hideItem () {
        if (!this.cloneCategories) {
          this.cloneCategories = cloneDeep(this.from.categories)
        }

        this.from.categories = cloneDeep(this.cloneCategories)

        for (let i in this.preset.items) {
          const item = this.preset.items[i]

          const index = this.from.categories.indexOf(item.from.category)
          if (index !== -1) {
            this.from.categories.splice(index, 1)
          }
        }
      },
      getProductTemplateCategories () {
        if (this.newItem.to.department === null) {
          return false
        }

        this.$emit('loading', true)

        this.newItem.to.category = null

        api.getCategories(this.preset.to.module.type, this.preset.to.module.identifier, this.newItem.to.department)
          .then(categories => {
            this.to.categories = categories
            this.$emit('loading', false)
          })
          .catch(() => notifier.error('Impossível carregar as categorias da Cnova.', 'Erro'))
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            category: this.newItem.from.category
          },
          to: {
            department: this.newItem.to.department,
            category: this.newItem.to.category
          }
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.category === item.from.category &&
            itemPreset.to.department === item.to.department && itemPreset.to.category === item.to.category
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'to.categories' (value) {
        this.showCategories = value.length > 0
      },
      'preset.items' (value) {
        this.items = value

        this.hideItem()
      },
      'newItem.from.category' () {
        this.emitEnabledAdd()
      },
      department (value) {
        this.newItem.to.department = value.code
        this.getProductTemplateCategories()
        this.emitEnabledAdd()
      },
      category (value) {
        this.newItem.to.category = value.code
        this.emitEnabledAdd()
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationAddItem.vue?75494edc